import { Check, Close } from "@mui/icons-material";
import { Autocomplete, Box, Button, TextField, Typography } from "@mui/material";
import Modal from "../../../../../App/Components/Modal/Modal";
import { useNotificationStore } from "../../../../../App/State/Stores/NotificationStore";
import createSlug from "../../../../../App/Utilities/createSlug";
import { useAddToGroupsState } from "./State/AddtoGroupState";

interface IAddToGroupProps {
  showAddToGroups: boolean;
  setShowAddToGroups: (value: boolean) => void;
}

export function AddToGroupOptions(props: IAddToGroupProps) {
  const {
    getters: { groupDropdownList, selectedGroups, isLoadingAddToGroups },
    handlers: { handleGroupSave, handleCancelAddToGroup, handleGroupsSelect },
  } = useAddToGroupsState(props.setShowAddToGroups);
  const snackbarSeverity = useNotificationStore((state) => state.type);

  return (
    <Modal
      title="Add Candidate to Groups"
      dataTestId="add-candidate-to-groups"
      isOpen={props.showAddToGroups}
      handleCloseModal={() => props.setShowAddToGroups(false)}
      content={
        <>
          <Autocomplete
            multiple
            data-test="addtogroups-autocomplete"
            options={groupDropdownList}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            onChange={handleGroupsSelect}
            getOptionLabel={(group) => group.name}
            renderOption={(props, option) => (
              <li {...props} key={`${createSlug(option.name)}-${Math.random().toString(36).substring(7)}`}>
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Groups"
                data-test="addtogroups-searchfield"
                error={snackbarSeverity === "error" || snackbarSeverity === "warning"}
                color={
                  snackbarSeverity === "error"
                    ? "error"
                    : snackbarSeverity === "warning"
                      ? "warning"
                      : "primary"
                }
              />
            )}
          />
          <Box sx={{ my: 1 }}>
            <Typography>
              {`${selectedGroups.length} ${selectedGroups.length === 1 ? "group" : "groups"} selected`}
            </Typography>
          </Box>
        </>
      }
      footerContent={
        <Box sx={{ display: "flex", gap: "2ch", justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            data-test="addtogroup-save"
            onClick={handleGroupSave}
            size="small"
            color="primary"
            aria-label="Add candidate to groups"
            title="Add candidate to groups"
            startIcon={<Check fontSize="small" />}
            disabled={selectedGroups.length === 0 || isLoadingAddToGroups}
          >
            Add to Groups
          </Button>
          <Button
            variant="outlined"
            data-test="addtogroup-cancel"
            onClick={handleCancelAddToGroup}
            size="small"
            color="warning"
            aria-label="Cancel adding candidate to groups"
            title="Cancel adding candidate to groups"
            startIcon={<Close fontSize="small" />}
          >
            Cancel
          </Button>
        </Box>
      }
    />
  );
}
